import {
    Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { useHistory } from "react-router-dom";
import { Props } from "./DialogError.model";

const DialogError = (props: Props) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Transacción fallida</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Alert severity="error">
              Intenta nuevamente. Si el problema continúa, comunícate con
              nosotros para una solución.
              <br />
              <br />
              Llámanos o escríbenos al{" "}
              <span style={{ whiteSpace: "nowrap" }}>+51 975 400 190</span> o a{" "}
              <span style={{ whiteSpace: "nowrap" }}>
                RaDi-languages@t-online.de
              </span>
              . ¡Con mucho gusto te apoyamos!
            </Alert>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={props.onReattempt}>
          Intentar nuevamente
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export { DialogError };
